import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { clientCMS } from "../../sanity/clientCMS.js";
import LoadingContainer from "../LoadingContainer/index.js";
import ErrorContainer from "../ErrorContainer/index.js";
import NoDataContainer from "../NoDataContainer/index.js";
import imageUrlBuilder from "@sanity/image-url";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PiNotePencilBold } from "react-icons/pi";
import { FiCalendar } from "react-icons/fi";
import { LuUserRoundPen } from "react-icons/lu";
import { TbNewsOff } from "react-icons/tb";
import "./RecentPosts.css";

export default function RecentPosts(props) {
  const [recentPostsData, setRecentPostsData] = useState(null);
  const [dataContainer, setDataContainer] = useState(null);
  const builder = imageUrlBuilder(clientCMS);

  function urlFor(source) {
    return builder.image(source);
  }

  useEffect(() => {
    setDataContainer(LoadingContainer);
    clientCMS
      .fetch(
        `*[_type == "post"] | order(_createdAt desc) [0...3] {
        title,
        slug,
         body[]{
            ...,
            asset -> {
                     ...,
            "_key": _id
            }
        },
        mainImage{
            asset->{
            _id,
            url
            },
        },
        "name": author->name,
        publishedAt,
        overview,
        "categories": categories[]->title
    }`,
      )
      .then((data) => {
        setRecentPostsData(data);
        if (data.length === 0)
          setDataContainer(
            <NoDataContainer
              icon={<TbNewsOff className="no-data-container-icon" />}
              message=" Sem destaques no momento"
            />,
          );
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!recentPostsData) setDataContainer(ErrorContainer);
        else setDataContainer(LoadingContainer);
      });
  }, []);

  return (
    <Container>
      <Row>
        <Col className="recent-posts-call-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <PiNotePencilBold
              style={{ color: props.iconColor }}
              className="recent-posts-call-first-icon"
            />
            DESTAQUES
          </h2>
        </Col>
      </Row>
      <Row>
        <Col className="recent-posts-call-second-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Acesse nossos avisos, notícias, projetos, eventos e novidades.
          </p>
        </Col>
      </Row>
      <Row>
        {recentPostsData && recentPostsData.length > 0
          ? recentPostsData &&
            recentPostsData.map((post, index) => (
              <Col key={index} className="noticias-col">
                <div
                  style={{ backgroundColor: props.white }}
                  className="article-card"
                >
                  <Link
                    to={"/destaques/" + post.slug.current}
                    key={post.slug.current}
                  >
                    <img
                      src={urlFor(post.mainImage.asset.url).width(348).url()}
                      alt="imagem artigo"
                      className="article-card-img"
                    />
                    <div className="article-card-title-content">
                      <div className="article-card-info">
                        <div
                          className="article-card-date"
                          style={{ color: props.textColor }}
                        >
                          <FiCalendar className="article-card-icon" />
                          {new Date(post.publishedAt).toLocaleDateString()}
                        </div>
                        <div
                          className="article-card-author"
                          style={{ color: props.textColor }}
                        >
                          <LuUserRoundPen className="article-card-icon" />
                          {post.name}
                        </div>
                      </div>
                      <h2
                        style={{
                          color: props.titleColor,
                          fontSize: props.subTitleSize,
                        }}
                      >
                        {post.title}
                      </h2>
                      <Container className="article-card-categories">
                        <Row>
                          {post.categories.map((category, id) => (
                            <Col
                              sm={4}
                              xs={4}
                              className="article-card-category-col"
                              key={id}
                              style={{ color: props.btnColor }}
                            >
                              <div className="article-card-category">
                                {category}
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Container>
                      <h4>{post.overview}</h4>
                      <div className="article-card-overlay" />
                    </div>
                  </Link>
                </div>
              </Col>
            ))
          : dataContainer}
      </Row>
    </Container>
  );
}
